import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { invariantIntlContext } from '../utils'
import { IntlContext } from 'react-intl'

export default class FormattedCurrency extends Component {
  static propTypes = {
    value: PropTypes.number.isRequired,
    currency: PropTypes.string,
    displayCurrency: PropTypes.bool,
    format: PropTypes.string,
    children: PropTypes.node,
  }

  static defaultProps = {
    displayCurrency: true,
  }

  getNormalizedCurrency() {
    const { currency } = this.props

    return currency ? currency.toLowerCase() : null
  }

  getFormattedValue() {
    return this.props.value / 100
  }

  getFormat(locale) {
    const { displayCurrency, format } = this.props
    const currency = this.getNormalizedCurrency()

    if (format) {
      return format
    }

    if (displayCurrency) {
      return locale === 'sv' && currency === 'sek' ? 'standardSymbolCurrency' : 'standardCurrency'
    }

    return 'amount'
  }

  render() {
    return (
      <IntlContext.Consumer>
        {intl => {
          invariantIntlContext(intl)
          const { formatNumber, locale } = intl
          const { children, value } = this.props

          const numberProps = {
            style: 'decimal',
          }

          const currency = this.getNormalizedCurrency()

          if (currency) {
            numberProps.style = 'currency'
            numberProps.currency = currency
          }

          const format = this.getFormat(locale)

          if (format) {
            numberProps.format = format
          }

          const formattedNumber =
            typeof value !== 'undefined' ? formatNumber(this.getFormattedValue(), numberProps) : null

          return typeof children === 'function' ? children(formattedNumber) : <span>{formattedNumber}</span>
        }}
      </IntlContext.Consumer>
    )
  }
}
